module.exports = __webpack_public_path__ + "img/default_campo.714b31e3.png";